import { render, staticRenderFns } from "./ParametrosBusca.vue?vue&type=template&id=1f674e0a&scoped=true"
import script from "./ParametrosBusca.vue?vue&type=script&lang=js"
export * from "./ParametrosBusca.vue?vue&type=script&lang=js"
import style0 from "./ParametrosBusca.vue?vue&type=style&index=0&id=1f674e0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f674e0a",
  null
  
)

export default component.exports